import {
  put, all, call, select, takeEvery, takeLatest, fork, cancel,
} from 'redux-saga/effects';

import { show as showNotification } from 'circe/notifications/actions';
import { exception } from 'circe/logger';
import * as I18n from 'circe/I18n';
import {
  start, started, createdMW, createMW, failedToCreateMW,
} from './actions';
import * as API from './api';

function* doStart(context, { payload }) {
  try {
    const { manifestOrderId } = payload;
    const resp = yield call(API.start, manifestOrderId);
    yield put(started(resp));
  } catch (e) {
    yield put(started(null));
    exception(e);

    const message = e.response && e.response.message
      ? e.response.message
      : I18n.str('unableToStartManifest', 'Unable to start manifesting.');

    yield put(showNotification(message, 'error'));
  }
}

function* doCreateMW(context, { payload }) {
  try {
    const { data } = payload;
    const resp = yield call(API.createMW, data);
    yield put(createdMW(resp));

    yield put(
      showNotification(
        I18n.str('masterWaybillSuccessful', 'Master waybill created successfully.'),
        'success',
      ),
    );
  } catch (e) {
    exception(e);
    yield put(failedToCreateMW());

    const message = e.response && e.response.message
      ? e.response.message
      : I18n.str('unableToCreateMW', 'Unable to create master waybill.');

    yield put(showNotification(message, 'error'));
  }
}

export default function* (context) {
  yield all([
    takeLatest(start().type, doStart, context),
    takeLatest(createMW().type, doCreateMW, context),
  ]);
}
